import React from 'react';
import classNames from 'classnames';
import { Box, theme, assignInlineVars } from '@fiverr-private/theme';
import { RING_STROKE_WIDTH } from '../constants';
import {
  ai_line_animation,
  ai_twist_animation,
  pathDrawAnimation,
  perimeterVar,
  strokeDashoffsetBaseVar,
  strokeDashoffsetMiddleVar,
} from './styles.ve.css';
import { type AvatarAnimationProps } from './types';
import { generatedSquarePath, getCircleAttributes, getPerimeter } from './utils';

const AvatarAnimation = ({ baseAvatarSize, shape, borderRadius, autoPlay, isLoading }: AvatarAnimationProps) => {
  const perimeter = getPerimeter(baseAvatarSize, shape);
  const circleAttributes = getCircleAttributes(baseAvatarSize, borderRadius, perimeter, isLoading);
  const squarePath = generatedSquarePath(baseAvatarSize, borderRadius);
  const animation = autoPlay ? classNames(pathDrawAnimation) : undefined;
  const trackColor = theme.colors.green_200;
  const progressColor = theme.colors.green_700;
  const reactProps = {
    stroke: trackColor,
    ...(isLoading && {
      className: ai_line_animation,
      stroke: theme.colors.purple_700,
    }),
  };
  return (
    <Box width={baseAvatarSize} height={baseAvatarSize} position="absolute">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox={`0 0 ${baseAvatarSize} ${baseAvatarSize}`}
        fill="none"
        className={isLoading ? ai_twist_animation : undefined}
        style={assignInlineVars({
          [perimeterVar]: perimeter.toString(),
          [strokeDashoffsetBaseVar]: `${perimeter + perimeter * 0.3}`,
          [strokeDashoffsetMiddleVar]: `${perimeter + perimeter * 0.6}`,
        })}
      >
        {shape === 'circle' ? (
          <>
            <rect {...circleAttributes} {...reactProps} />
            {!isLoading && <rect {...circleAttributes} stroke={progressColor} className={animation} />}
          </>
        ) : (
          <>
            <path stroke={trackColor} d={squarePath} strokeWidth={RING_STROKE_WIDTH} />
            <path
              stroke={progressColor}
              className={animation}
              d={squarePath}
              strokeWidth={RING_STROKE_WIDTH}
              strokeDasharray={perimeter}
              strokeDashoffset={0}
            />
          </>
        )}
      </svg>
    </Box>
  );
};

AvatarAnimation.displayName = 'AvatarAnimation';
export default AvatarAnimation;
